<template>
  <div class="min-h-screen bg-gray-900 text-white py-6 px-4 sm:px-6 lg:px-8">
    <div class="max-w-7xl mx-auto">
      <DataListControls v-model:searchText="searchText" v-model:pageSize="pageSize" v-model:currentPage="currentPage"
        collectionName="projects" @dataUpdate="handleDataUpdate">
        <template #actions>
          <button @click="openAddForm"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            Add Project
          </button>
        </template>
        <template #table>
          <div class="overflow-x-auto overflow-y-visible">
            <table class="min-w-full divide-y divide-gray-700">
              <thead class="bg-gray-800">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">Actions
                  </th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">Title</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">Category
                  </th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">Status
                  </th>


                </tr>
              </thead>
              <tbody class="bg-gray-700 divide-y divide-gray-600">
                <tr v-for="project in projects" :key="project.id" class="hover:bg-gray-600">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium relative">
                    <div class="relative inline-block text-left dropdown-container">
                      <button @click="toggleDropdown(project.id)"
                        class="inline-flex items-center justify-center w-8 h-8 bg-gray-600 bg-opacity-50 hover:bg-opacity-75 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500">
                        <svg class="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                        </svg>
                      </button>

                      <div v-if="openDropdownId === project.id"
                        class="absolute left-0 top-0 mt-10 w-40 bg-gray-800 bg-opacity-95 backdrop-blur-sm border border-gray-600 rounded-lg shadow-lg z-50">
                        <div class="py-1">
                          <button @click="openEditForm(project); closeDropdown()"
                            class="w-full text-left px-4 py-2 text-sm text-blue-400 hover:bg-blue-600 hover:bg-opacity-20 hover:text-blue-300 transition-all duration-200 flex items-center">
                            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                          </button>
                          <button @click="openDeleteDialog(project); closeDropdown()"
                            class="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-600 hover:bg-opacity-20 hover:text-red-300 transition-all duration-200 flex items-center">
                            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-white">
                    <div class="flex items-center">
                      <div class="h-10 w-10 flex-shrink-0 mr-3">
                        <img
                          :src="project.imageURLs && project.imageURLs.length ? project.imageURLs[0] : 'https://via.placeholder.com/40'"
                          class="h-10 w-10 rounded object-cover" alt="Project image" />
                      </div>
                      {{ project.title || 'N/A' }}
                    </div>
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-white">{{ project.categoryName || 'N/A' }}</td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <label class="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" :checked="project.status" @change="toggleStatus(project)"
                        class="sr-only peer" :disabled="updatingStatus === project.id">
                      <div
                        class="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                      </div>
                      <span class="ml-3 text-sm font-medium"
                        :class="project.status ? 'text-green-400' : 'text-gray-400'">
                        {{ project.status ? 'Active' : 'Inactive' }}
                      </span>
                    </label>
                  </td>


                </tr>
                <tr v-if="!projects.length && !isLoading" class="bg-gray-700">
                  <td colspan="4" class="px-6 py-4 text-center text-gray-400">
                    No Data found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </DataListControls>

      <ProjectForm :isVisible="showForm" :projectId="selectedProjectId" @onEmitHandleEvent="handleFormEvent" />
      <DeleteConfirmation :isVisible="showDeleteDialog" :deleteId="selectedProjectId"
        :elementName="selectedProjectTitle" elementCategory="Project" collectionName="projects"
        :isLastRecordOnPage="isLastRecordOnPage" @onEmitHandleEvent="handleDeleteEvent" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { projectFirestore } from '@/firebase/config';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import DataListControls from '@/components/DataListControls.vue';
import ProjectForm from '@/components/ProjectForm.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

const searchText = ref('');
const pageSize = ref(10);
const currentPage = ref(1);
const projects = ref([]);
const categories = ref({});
const showForm = ref(false);
const showDeleteDialog = ref(false);
const selectedProjectId = ref(null);
const selectedProjectTitle = ref('');
const isLoading = ref(false);
const openDropdownId = ref(null);
const updatingStatus = ref(null);

const isLastRecordOnPage = computed(() => {
  return projects.value.length === 1 && currentPage.value > 1;
});

const fetchCategories = async () => {
  try {
    const categoriesCol = collection(projectFirestore, 'categories');
    const categoriesSnapshot = await getDocs(categoriesCol);
    categories.value = categoriesSnapshot.docs.reduce((acc, doc) => {
      acc[doc.id] = doc.data().name;
      return acc;
    }, {});
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
};

const handleDataUpdate = async (data) => {
  // Fetch categories if not already fetched
  if (Object.keys(categories.value).length === 0) {
    await fetchCategories();
  }

  // Map projects with category names
  projects.value = data.map(project => ({
    ...project,
    categoryName: categories.value[project.categoryId] || 'Unknown'
  }));
  isLoading.value = false;
};

const openAddForm = () => {
  selectedProjectId.value = null;
  showForm.value = true;
};

const openEditForm = (project) => {
  selectedProjectId.value = project.id;
  showForm.value = true;
};

const openDeleteDialog = (project) => {
  selectedProjectId.value = project.id;
  selectedProjectTitle.value = project.title || 'Unnamed Project';
  showDeleteDialog.value = true;
};

const toggleDropdown = (projectId) => {
  openDropdownId.value = openDropdownId.value === projectId ? null : projectId;
};

const closeDropdown = () => {
  openDropdownId.value = null;
};

const toggleStatus = async (project) => {
  try {
    updatingStatus.value = project.id;
    const newStatus = !project.status;

    // Update in Firestore
    const projectRef = doc(projectFirestore, 'projects', project.id);
    await updateDoc(projectRef, {
      status: newStatus
    });

    // Update local state
    const projectIndex = projects.value.findIndex(p => p.id === project.id);
    if (projectIndex !== -1) {
      projects.value[projectIndex].status = newStatus;
    }

    console.log(`Project ${project.title} status updated to: ${newStatus ? 'Active' : 'Inactive'}`);
  } catch (error) {
    console.error('Error updating project status:', error);
    alert(`Failed to update project status: ${error.message}`);
  } finally {
    updatingStatus.value = null;
  }
};

// Close dropdown when clicking outside
const handleClickOutside = (event) => {
  if (!event.target.closest('.dropdown-container')) {
    closeDropdown();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

const handleFormEvent = (event, hasError = false, message = '') => {
  if (event === 'close') {
    showForm.value = false;
  } else if (event === 'created' || event === 'updated') {
    showForm.value = false;
    if (event === 'created') {
      currentPage.value = 1;
    }
  } else if (event === 'error') {
    console.error('Form error:', message);
    alert(`Project form error: ${message}`);
  }
};

const handleDeleteEvent = (event, hasError = false, message = '') => {
  if (event === 'close') {
    showDeleteDialog.value = false;
  } else if (event === 'deleted') {
    showDeleteDialog.value = false;
    if (isLastRecordOnPage.value) {
      currentPage.value = Math.max(1, currentPage.value - 1);
    }
  } else if (event === 'error') {
    console.error('Delete error:', message);
    alert(`Failed to delete project: ${message}`);
  }
};
</script>

<style scoped>
tr {
  transition: background-color 0.2s ease;
}

button {
  transition: color 0.2s ease, background-color 0.2s ease;
}
</style>